import { register } from 'larasnap';
import SnapGrid from './SnapGrid';

register(SnapGrid);
